/* eslint-disable */

import React from 'react'
import { createScope, map, transformProxies } from './helpers'

const scripts = [

]

let Controller

class CtaBoxView extends React.Component {
  static get Controller() {
    if (Controller) return Controller

    try {
      Controller = require('../controllers/CtaBoxController')
      Controller = Controller.default || Controller

      return Controller
    }
    catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = CtaBoxView

        return Controller
      }

      throw e
    }
  }

  componentDidMount() {
    /* View has no WebFlow data attributes */

    scripts.concat(null).reduce((active, next) => Promise.resolve(active).then((active) => {
      const loading = active.loading.then((script) => {
        new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script)

        return next
      })

      return active.isAsync ? next : loading
    }))
  }

  render() {
    const proxies = CtaBoxView.Controller !== CtaBoxView ? transformProxies(this.props.children) : {
      'signin': [],
      'signup': [],
    }

    return (
      <span>
        <style dangerouslySetInnerHTML={{ __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ame-89b37f.webflow.css);
        ` }} />
        <span className="af-view">
          <div id="CTABox" className="af-class-login-prompt">
            {map(proxies['signin'], props => <a id="SignInButton" href="#" {...{...props, className: `af-class-login af-class-pagebutton af-class-header-button w-button ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Sign In</React.Fragment>}</a>)}
            {map(proxies['signup'], props => <a id="SignUpButton" href="#" {...{...props, className: `af-class-get-started af-class-pagebutton af-class-header-button w-button ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Sign Up</React.Fragment>}</a>)}
          </div>
        </span>
      </span>
    )
  }
}

export default CtaBoxView

/* eslint-enable */